<template>
  <div class="sy-tinymce-editor">
    <editor class="editor" ref="editor" v-model="value" v-bind="$attrs" v-on="$listeners" :init="initConfig"></editor>
  </div>
</template>

<script>
/* Import TinyMCE */
import tinymce from 'tinymce'
import Editor from '@tinymce/tinymce-vue'

/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default'

/* A theme is also required */
import 'tinymce/themes/silver'

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css'

/* Import plugins */
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/code'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/table'
import 'tinymce/plugins/image'
import './plugins/placeholder'

import './langs/zh_CN'
import defaultConfig from './config.js'
import {imageUploadHandler, pickerCallbackHandler} from './utils.js'
export default {
  name: 'sy-tinymce-editor',
  components: {Editor},
  props: {
    // placeholder
    editorPlaceholder: {
      type: String,
      default: ''
    },
    // 绑定的数据
    value: {
      type: String,
      default: ''
    },
    // 上传地址
    uploadUrl: {
      type: String,
      default: '/purchaser/upload/publicUploadImg'
    },
    // 自定义配置
    init: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    initConfig () {
      return Object.assign({}, defaultConfig, this.init, {
        placeholder: this.editorPlaceholder,
        file_picker_callback: pickerCallbackHandler,
        images_upload_handler: (blobInfo, success, failure) => imageUploadHandler(blobInfo, success, failure, this.uploadUrl),
        content_style: this.init.content_style + defaultConfig.content_style,
        font_formats: this.init.font_formats + defaultConfig.font_formats
      })
    }
  },
  created () {
  },
  async mounted () {
    tinymce.init({})
  },
  methods: {
    getCoreEditor () {
      return this.$refs['editor'].editor
    }
  }
}
</script>

<style scoped>
.sy-tinymce-editor{
  padding-bottom: 2px; /*tinymce 会增加border，多出2px*/
}
.editor{
  height: 100%;
}
</style>
<style>
.tox-tinymce-aux {
  z-index: 3000 !important;
}
.tox .tox-toolbar-overlord {
  border-bottom: 1px solid #ccc;
}
</style>
